/**
 * Cart Remove Product Action
 * Triggered by: arc:action:cartRemoveProduct
 */

export const runCartRemoveProduct = async (data = {}) => {
    try {
        const { variantId, lineItem, key } = data;

        // Determine the item identifier (prioritize key, then lineItem, then variantId)
        let itemIdentifier = key || lineItem;
        
        if (!itemIdentifier && variantId) {
            // Find the line item key from variant ID
            const cart = Alpine.store('cart');
            const item = cart.getItem(variantId);
            if (item) {
                itemIdentifier = item.key;
            }
        }

        if (!itemIdentifier) {
            throw new Error('Item identifier (key, lineItem, or variantId) is required');
        }

        // Dispatch loading start event
        window.dispatchEvent(new CustomEvent('cart:remove_loading_start', { detail: { itemIdentifier } }));

        // Use Alpine cart store
        await Alpine.store('cart').remove(itemIdentifier);

        // Dispatch success event
        window.dispatchEvent(new CustomEvent('cart:item_removed', { detail: { itemIdentifier } }));
        window.dispatchEvent(new CustomEvent('cart:updated', { detail: { itemIdentifier, quantity: 0 } }));
        window.dispatchEvent(new CustomEvent('cart:remove_loading_end'));

        return {
            success: true,
            message: 'Item removed from cart successfully'
        };

    } catch (error) {
        console.error('Error removing item from cart:', error);
        return {
            success: false,
            error: error.message
        };
    }
};

export default runCartRemoveProduct;
